import React, { Fragment } from 'react';

import type { CampaignInfoItem as CampaignInfoItemData } from 'features/campaigns';
import CampaignInfoItem from './CampaignInfoItem';
import CampaignInfoSeparator from './ui/CampaignInfoSeparator';

interface CampaignInfoListProps {
  items: CampaignInfoItemData[];
  campaignId?: string;
  hasMany: boolean;
}

const CampaignInfoList: React.FC<CampaignInfoListProps> = ({ items, campaignId, hasMany }) => (
  <>
    {items.map((item, index) => {
      const isLastItem = index === items.length - 1;
      
      return (
        <Fragment key={index}>
          <CampaignInfoItem
            type={item.type}
            iconSrc={item.iconSrc}
            label={item.label}
            value={item.value}
            suffix={item.suffix}
            campaignId={campaignId}
          />
          <CampaignInfoSeparator show={!isLastItem && hasMany} />
        </Fragment>
      );
    })}
  </>
);

export default CampaignInfoList;
